export default __webpack_public_path__ + "images/py-51b0bef3321042c047177de5e4f42e7c.svg";